var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-block position-relative" }, [
    _c("div", { class: _vm.loadingClasses }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query"
          }
        ],
        ref: "input",
        staticClass: "form-control",
        attrs: {
          type: "text",
          placeholder: _vm.placeholder,
          name: _vm.name,
          autocomplete: "off"
        },
        domProps: { value: _vm.query },
        on: {
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.query = $event.target.value
            },
            _vm.handleInput
          ],
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              return _vm.handleDown($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              return _vm.handleUp($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.handleEnter($event)
            }
          ]
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "dropdown",
        staticClass:
          "dropdown-menu dropdown-menu-anim dropdown-menu-fit dropdow-menu-suggest ps ps--active-y mw-100",
        class: { show: _vm.isVisibleSuggestions && !_vm.isLoading },
        staticStyle: { "min-width": "100%" },
        style: _vm.dropdownStyles,
        attrs: { "data-scroll": "true" }
      },
      [
        _c(
          "div",
          { staticClass: "kt-scroll" },
          _vm._l(_vm.suggestions, function(item, index) {
            return _c(
              "a",
              {
                key: index,
                ref: "suggestions",
                refInFor: true,
                staticClass: "dropdown-item flex-column",
                class: { cursor: index === _vm.cursor },
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.select(item)
                  },
                  mouseover: function($event) {
                    return _vm.onSuggestionHover(index)
                  }
                }
              },
              [
                _vm._t("default", [_vm._v(_vm._s(item.value))], {
                  suggestion: item
                })
              ],
              2
            )
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }